import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const Link = styled(RouterLink)`
  color: ${({ theme }) => theme.colors.secondary};
  text-decoration: none;
  font-size: 0.8rem;
  line-height: 1rem;
  font-weight: bold;
  margin-left: 1rem;
  cursor: pointer;
  &:active,
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
  }
  ${({ uppercase }) => uppercase && 'text-transform: uppercase;'}
`;

export default Link;
